import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, Validation } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { FSTREAM_Image } from "./FSTREAM_Image.model";
import { Dock } from "./Dock.model";
import { Face } from "./Face.model";
import { Trucker } from "./Trucker.model";
import { RegexType } from "../../services/RegexPatternLibrary";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";


@Register({
  isModelEntity: true, namespace: 'Tenant', entityName: 'TruckerActivity' // optionnel car par defaut utilise le nom de classe
})
export class TruckerActivity extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required, IPropretyAttribute.DateRangeFilterColumn] })
  startDate!: Date | undefined;

  // Pas de DateRangeFilterColumn : la plage de dates ne porte que sur la date de debut,
  // seule propriete que le composant de liste retient.
  endDate?: Date;

  // Comme visitId : l'identifiant est généré côté serveur, pas saisi ni requis au formulaire.
  @PropretyAttributes({ attributes: [IPropretyAttribute.SortColumn, IPropretyAttribute.FilterColumn] })
  truckerActivityID!: number;


  truckerFullName!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_PointOfService!: number;

  fK_Image_Photo?: number;

  fK_Image_Signature?: number;

  fK_Image_Agreements?: number;

  fK_Dock?: number | null;

  fK_Face?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  fK_Responsibles?: string;

  fK_Attachments?: string;

  @NestedProperty({ TargetType: FSTREAM_Image })
  attachments?: FSTREAM_Image[] | null;

  @Validation({ propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}`, minLength: 2, maxLength: 50 })
  trailerNumber?: string;

  fK_Trucker?: number;

  @Validation({ minLength: 2, maxLength: 255, propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}` })
  title?: string;

  @Validation({ minLength: 8, maxLength: 20, pattern: '^\\s*2(?:2977[0-9]{3}|297[89][0-9]{4}|[3-5][0-9]{6}|6[0-9]{6})\\s*$', validationErrorMessage: "vues.qr-code.truckerActivity.invalid-bill-of-landing-message" })
  billOfLanding?: string;

  sCACCode?: string;

  @Validation({ minLength: 2, maxLength: 255, propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}` })
  portOfEntry?: string;

  @Validation({ minLength: 2, maxLength: 255, propertyType: `${RegexType.Alphanumeric}|${RegexType.WithSpecialChars}` })
  licenceNumber?: string;

  deliveryType?: number;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService | null;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imagePhoto?: FSTREAM_Image | null;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageSignature?: FSTREAM_Image | null;

  @NestedProperty({ TargetType: FSTREAM_Image })
  imageAgreements?: FSTREAM_Image | null;

  @NestedProperty({ TargetType: Dock })
  dock?: Dock | null;

  @NestedProperty({ TargetType: Face })
  face?: Face | null;

  @NestedProperty({ TargetType: Trucker })
  trucker?: Trucker | null;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Pos: string[] = [];

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  selectedPK_Trucker: string[] = [];


  GetType(): IEntityMetaData {
    return TruckerActivity.getMetaData();
  }
}
